import React, { memo } from 'react'

const NoticeGuide = ({ isAeon, isOffline }) => {
  return (
    <section className="notice-container">
      <h3>Lưu ý:</h3>
      <ol>
        <li>
        Hệ thống AI là hệ thống trí tuệ nhân tạo.
        </li>
        <li>
        Chương trình kiểm tra sức khỏe răng miệng với hệ thống AI của P/S dành cho mọi đối tượng và miễn phí, tuy nhiên, trẻ em dưới 16 tuổi cần có sự giám sát và hướng dẫn của phụ huynh.
        </li>
        <li>
        Hình ảnh răng miệng mà bạn cung cấp cho hệ thống AI sẽ được bảo mật tuyệt đối và được xóa ngay khi bạn hoàn thành quá trình kiểm tra.
        </li>
        <li>
        Khi bạn tham gia chương trình, bạn cần hiểu rằng bạn đang tương tác với AI chứ không phải con người. Chúng tôi sẽ xử lý các dữ liệu cá nhân mà bạn cung cấp theo Thông báo quyền riêng tư của Unilever mà bạn cần đọc và đồng ý trước khi đăng ký tham gia.
        </li>
        <li>
        Nếu tham gia tại siêu thị GO! (BigC), Saigon Co.op, AEON, mỗi số điện thoại sẽ tương ứng với 1 lần nhận báo cáo chi tiết & 01 voucher Got It trị giá 10.000đ để mua các sản phẩm P/S tại hệ thống siêu thị GO! (BigC), Saigon Co.op, AEON.
        </li>
        <li>
        Liên hệ Hotline <b>028 38236651</b> hoặc Fanpage P/S Bảo Vệ Nụ Cười Việt Nam nếu cần thêm thông tin chi tiết.
        </li>
        {isOffline && !isAeon &&
          <li>
          Số lượng voucher giới hạn theo từng ngày: thứ 2 - thứ 5: 500 voucher/ ngày, thứ 6 - chủ nhật: 3000 voucher/ngày.
          </li>
        }
      </ol>
    </section>
  )
}
export default memo(NoticeGuide)